import { Typography } from "@mui/material";
import React from "react";
import "./DsaPage.css";

function Dsaprofile() {
  const obj = [
    {
      name: "Leetcode - 400+ Problems",
      url: "https://leetcode.com/DivyeshVyas/",
    },
    {
      name: "CodeChef - 4 ⭐ star ",
      url: "https://www.codechef.com/users/divyesh_vyas25",
    },
    {
      name: "HackerRank - 5 ⭐ star",
      url: "https://www.hackerrank.com/divyeshvyas?hr_r=1",
    },
    {
      name: "CodeForces",
      url: "https://codeforces.com/profile/divyeshvyas",
    },
    {
      name: "GeeksforGeeks",
      url: "https://auth.geeksforgeeks.org/user/divyeshvyas562/practice/",
    },
  ];

  return (
    <div className="dsa-profile-section">
      <Typography variant="h6" color="white">
        {" "}
        &#60; DSA Profile &#62;
      </Typography>

      {obj.map((dsa, key) => (
        <div className="profile-part">
          <Typography variant="p" component="p" sx={{ margin: "5px 0px" }}>
            &#60; Title &#62; <span>{dsa.name} </span> &#60; /Title &#62;
          </Typography>

          <Typography variant="p" component="p">
            &#60; Link &#62;
            <span>
              &nbsp; <a href={dsa.url}>Click Me</a> &nbsp;
            </span>
            &#60; /Link &#62;
          </Typography>
        </div>
      ))}
      <Typography variant="h6" color="white">
        {" "}
        &#60; DSA Profile &#62;
      </Typography>
    </div>
  );
}

export default Dsaprofile;
